<form nz-form [formGroup]="form" se-container="1" nzLayout="vertical">
    <nz-col nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="account" nzRequired="true">Bank Account</nz-form-label>
        <nz-form-control nzErrorTip="Bank Account is required">
            <app-cac-select formControlName="account" [allowClear]="false" required labelType="name"
            defaultType="deposit"></app-cac-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="description">Description</nz-form-label>
        <nz-form-control>
          <app-text-input formControlName="description" maxlength="50"></app-text-input>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="referenceNo">Cheque/Ref No.</nz-form-label>
        <nz-form-control>
          <app-text-input formControlName="referenceNo" maxlength="50"></app-text-input>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="amount">Amount</nz-form-label>
        <nz-form-control nzErrorTip="Amount is required">
          <app-currency-input formControlName="amount" class="text-right"></app-currency-input>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="bankChargesAmount">Bank Charges Amount</nz-form-label>
        <nz-form-control>
          <nz-input-group nzCompact>
            <app-currency-input formControlName="bankChargesAmount" class="text-right" [ignoreZero]="true"></app-currency-input>
            <button type="button" nz-button nzType="default" (click)="bankChargesModal()">
              <span nz-icon nzType="ellipsis"></span>
            </button>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
</form>
  